import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseSources } from 'services/connectwise';

export const ThunkGetConnectwiseSources = createAsyncThunk(
  'connectwise/getConnectwiseSources',
  (psaId: number) =>
    getConnectwiseSources(psaId)
      .then(res => res.data)
      .then(data => data.sort((a, b) => a.name.localeCompare(b.name))),
);

export default {};
